module.exports = __webpack_public_path__ + "img/2.66aa3c72.png";